import { useApi } from "~/composables/useApi";
import { Aggregation, Products } from "~/modules/GraphQL/types";
import getProductFilter from "~/modules/catalog/category/components/filters/command/getProductFilter.gql";
import { GetProductSearchParams } from "~/modules/catalog/product/types";

export function useProductFilter() {
	const { query } = useApi();

	const search = async (variables: GetProductSearchParams): Promise<Aggregation[]> => {
		const { data } = await query<{ products: Products }>(getProductFilter, variables);

		return data?.products?.aggregations ?? [];
	};

	return {
		search,
	};
}

export default useProductFilter;
